module.exports = __webpack_public_path__ + "media/src/images/og-d41d8cd98f00b204e9800998ecf8427e.png";